import {fromJS } from 'immutable';
import config from '../../../config';
import actions from '../../constants/portal/services';

export const servicesIsLoading = (data) => ({
  type: actions.SERVICES_IS_LOADING,
  data
});

export const loadServices = (limit=25, offset=0) => (dispatch) => {
  dispatch(servicesIsLoading(true))
  fetch(`${config.apiHost}/service_classification/?limit=${limit}&offset=${offset}`)
  .then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  })
  .then((json) => {
    const data = fromJS(json.results);
    dispatch({
      type: actions.LOAD_SERVICES,
      data
    });
    dispatch(servicesIsLoading(false))
  })
  .catch(e => console.log(e))
};

export const searchServicesAdmin = (name, limit, offset) => (dispatch) => {
  dispatch(servicesIsLoading(true))
  fetch(`${config.apiHost}/institution_service/?search=${name}&limit=${limit}&offset=${offset}`)
  .then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  })
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_SERVICES,
      data
    });
    dispatch(servicesIsLoading(false))
  })
  .catch(e => console.log(e))
};


export const loadServiceDetailAdmin = (id) => (dispatch) => {
  dispatch(servicesIsLoading(true))
  fetch(`${config.apiHost}/institution_service/${id}/`)
  .then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  })
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_SERVICE_DETAIL,
      data
    });
    dispatch(servicesIsLoading(false))
  })
  .catch(e => console.log(e))
};


export const searchServices = (name ="", limit="", offset="") => (dispatch) => {
  dispatch(servicesIsLoading(true))
  fetch(`${config.apiHost}/service_classification/?search=${name}&limit=${limit}&offset=${offset}`)
  .then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  })
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_SERVICES,
      data
    });
    dispatch(servicesIsLoading(false))
  })
  .catch(e => console.log(e))
};


export const loadServiceDetail = (id) => (dispatch) => {
  dispatch(servicesIsLoading(true))
  fetch(`${config.apiHost}/service_classification/${id}/`)
  .then((response) => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  })
  .then((json) => {
    const data = fromJS(json);
    dispatch({
      type: actions.LOAD_SERVICE_DETAIL,
      data
    });
    dispatch(servicesIsLoading(false))
  })
  .catch(e => console.log(e))
};




// WEBPACK FOOTER //
// ./src/redux/actions/portal/services.js